import { parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const formatDate = (date: Date | string, format: string): string => {
  let dateData = new Date();
  if (typeof date === 'string') {
    dateData = parseISO(date);
  } else {
    dateData = date;
  }
  return formatInTimeZone(dateData, 'Etc/GMT', format);
};

export default formatDate;
